<template>
  <div class="home">
    <div id="Middle">
        <div id="PraViewTop">
            <!-- <router-link :to='{path:"/practise/set"}' class="router">   -->
            <div @click="toPathClick('/practise/set')" class="router">             
                <span class="setText">练习数量设置</span>
                <img class="icon" src="@/../public/icon/set.png">
            </div>
            <!-- </router-link>                           -->
        </div>
        <div class="practiseBox">
            <!-- <div></div> -->
            <div class="wordPraView quedays">
                <div class="practiseCenter">
                    <span class="days_all">第</span>
                    <b class="days_all" id="days_num">{{questionMessage.days}}</b>
                    <span class="days_all">天</span>
                </div>
                <div class="practiseNumber">
                    <div class="build_que_each_Num">
                        <span class="data_number">
                            <span class="number_tittle">计划练习</span>
                            <div class="each_time_text">
                                <b class="each_time_color">{{questionMessage.PlanNewQueNum+questionMessage.PlanOldQueNum}}</b>
                            </div>
                        </span>
                        <div class="line"></div>
                        <span class="data_number">
                            <span class="number_tittle">已经练习</span>
                            <div class="each_time_text">
                                <b class="each_time_color">{{questionMessage.NewHavePractiseNum+questionMessage.OldHavePractiseNum}}</b>
                            </div>
                        </span>
                        <div class="line"></div>
                        <span class="data_number">
                            <span class="number_tittle">剩余练习</span>
                            <div class="each_time_text">
                                <b class="each_time_color" v-if="questionMessage.NewQueSurplusNum + questionMessage.OldQueSurplusNum<0">0</b>
                                <b class="each_time_color" v-else>{{questionMessage.NewQueSurplusNum + questionMessage.OldQueSurplusNum}}</b>
                            </div>
                        </span>
                    </div>
                </div>

                <div class="practiseCenter" id="start">
                    <div @click="toPathClick('/practise/question')">
                        <span class="btnQue">开始练习</span>
                    </div>
                </div>            
            </div>
            <div class="practiseItemForm" id="report">
                <div @click="toPathClick('/practise/set')" class="practiseItem">
                    <img :src="iconUrl+'seting.png'" class="iconSize">
                    <span id="report_show">
                        练习设置
                    </span>
                </div>
                <div @click="toPathClick('/practise/report')" class="practiseItem">
                    <img :src="iconUrl+'report.png'" class="iconSize">
                    <span id="report_show">
                        练习报告
                    </span >
                </div>
                <div @click="toPathClick('/practise/record')" class="practiseItem">
                    <img :src="iconUrl+'record.png'" class="iconSize">
                    <span id="report_show">
                        练习记录
                    </span >
                </div>
                <div @click="toPathClick('/practise/emergency')" class="practiseItem">
                    <img :src="iconUrl+'test.png'" class="iconSize">
                    <span id="report_show">
                        紧急练习
                    </span >
                </div>
            </div>
        </div>

        <div v-if="showCoupon" class="couponShade">
            
            <div class="couponForm">
                <img :src="iconUrl+'closebutton.png'" class="closebutton" @click="closebutton">
                <div class="textAndCode">
                        <div>扫码添加客服微信</div>
                        <div>免费领取3个月会员</div>
                    <img :src="webUrl+'/static/otherImage/vx_service.jpg'" class="vx_service_img">
                </div>
            </div>    
        </div>


        <div v-if="showMessage" class="shade">
            <div class="messageForm">
                <div class="messageTitle">
                    <b>温馨提示</b>
                </div>
                <div class="messageText">
                    <span class="messageSpan">{{showText.messageWarning}}</span>
                </div>
                <div class="messageBtn" @click="closeMessageForm">
                    <span>确定</span>
                </div>
            </div>
        </div>


        <div v-if="loading" class="loadingForm">
            <div class="message">
                <span class="circle"></span>
                <span class="showText">{{showText.loadingText}}</span>
            </div>
        </div>

        <div v-if="saveSuccess" class="loadingForm">
            <div class="message">
                <span class="showText">
                    {{showText.successText}}
                </span>
            </div>
        </div>
    </div>

    <div id="Banner">
        <div class="practise" @click="bannerClick('/')">
            <img src="@/../public/icon/practise2.png">
            <span>练习</span>
        </div>
        <div class="text" @click="bannerClick('/test')">
            <img src="@/../public/icon/question1.png">
            <span>检验</span>
        </div>
        <div class="text" @click="bannerClick('/question')">
            <img src="@/../public/icon/word1.png">
            <span>题卡</span>
        </div>
        <div class="text" @click="bannerClick('/my')">
            <img src="@/../public/icon/my1.png">
            <span>我的</span>
        </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {check_Login,check_vip_date,storage} from "@/myjs/utils";

export default {
    data(){
        return{
            loading:false,
            saveSuccess:false,
            showMessage:false,
            showText:{
                loadingText:'',
                successText:'',
                messageWarning:'',
            },
            
            toBanner:false,
            canToPath:false,
            canToLogin:false,
            canShowText:true,
            iconUrl:this.$store.state.webUrl+"/static/icon/",
            webUrl:this.$store.state.webUrl,
            username:this.$store.state.username,
            userID:this.$store.state.userID,
            questionMessage:{
                NewHavePractiseNum:0,
                NewQueExpirationNum:0,
                NewQueNum:0,
                NewQueNumUpperLimit:0,
                NewQueSurplusNum:0,
                OldHavePractiseNum:0,
                OldQueExpirationNum:0,
                OldQueNum:0,
                OldQueNumUpperLimit:0,
                OldQueSurplusNum:0,
                PlanNewQueNum:0,
                PlanOldQueNum:0,
                allQueNum:0,
                days:0,
            },
            showCoupon:false,
        }
    
    },
    mounted(){
        
    },

    activated() {
        // 组件被激活时调用fetchData方法
        this.get_localData();
        this.check_Login();
        this.initialization();
        this.checkDateAndRefreshIfNeeded();
    },

    //导航守卫
    beforeRouteLeave(to, from, next) {
        if(to.path=="/question" || to.path=="/my" || to.path=="/test"){
            //如果是点击底部导航则放行，否则不放行
            if(this.toBanner){
                next();
            }else{
                next(false);
            }
        }else if(to.path=="/practise/question" || to.path=="/practise/set" || to.path=="/practise/report" || to.path=="/practise/record" || to.path=="/practise/emergency") {
            //如果是点击按钮触发this.canToPath=true则放行，否则不放行
            if(this.canToPath){
                next();
            }else{
                next(false);
            }
        }else if (to.path=="/addtelephone") {
            //如果是登录时效触发的放行，否则不放行
            if(this.canToLogin){
                next();
            }else{
                next(false);
            }
        }else if (to.path=="/login") {
            //如果是登录时效触发的放行，否则不放行
            if(this.canToLogin){
                if(this.$store.state.userID == ""){
                    next();
                }else{
                    next(false);
                }
            }else{
                next(false);
            }
        }else{
            next();
        }
    },
    

    methods:{
        //页面初始化
        initialization(){
            this.showMessage = false;
            this.toBanner = false;
            this.canToPath = false;
            this.canToLogin = false;
            this.username = this.$store.state.username;
            this.userID = this.$store.state.userID;
            this.showCoupon = false;
        },

        //获取本地存储数据
        get_localData(){
            const localquestionMessage = storage.get("practice_questionMessage");
            if (localquestionMessage) {
                this.questionMessage = localquestionMessage;
            }
        },


        //登录验证
        async check_Login(){
            const localquestionMessage = storage.get("practice_questionMessage");
            if(!localquestionMessage){
                this.showText.loadingText = "数据加载中..."
                this.loading = true;
            }
            try {
                let data = await check_Login(this.$store.state.webUrl,this.$store.state.userID);
                console.log("this.$store.state.webUrl",this.$store.state.webUrl)
                if(data.status){
                    // if (data.isHavePhone) {
                    //     await this.getPraView();  //加载练习页面数据
                    //     await this.check_vip_date();  //检查vip是否到期
                    // }else {
                    //     this.canToLogin = true;
                    //     this.$router.push({path:"/addtelephone"});
                    // }
                    await this.getPraView();  //加载练习页面数据
                    await this.check_show_coupon();
                    await this.check_vip_date();  //检查vip是否到期
                }else{
                    this.canToLogin = true;
                    this.$router.push({path:"/login"});
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                this.loading = false; // 请求完成时隐藏加载指示器
            }
        },

        //检查会员有效期
        async check_vip_date(){
            let data = await check_vip_date(this.$store.state.webUrl,this.$store.state.userID);
            if (!data.status) {
                this.showMessage = true;
                console.log("data.data.vip_date:",data.data.vip_date)
                this.showText.messageWarning = "会员已于"+data.data.vip_date+"到期，请充值。"
            }
        },

        //检查是否展示领取免费使用名额面板
        async check_show_coupon(){
            try {
                let response = await axios.post(this.$store.state.webUrl+"/app01/check_show_coupon",{
                    userID:this.userID, 
                    activeKind:"coupon3months"
                });
                let data = response.data
                console.log("check_show_coupon:::",data)
                if (data.status) {
                    this.showCoupon = true;
                }else{
                    this.showCoupon = false;
                }
            } catch (error) {
                
                console.error('Error fetching data:', error);
            }
        },

        //关闭提醒信息
        closeMessageForm(){
            this.showMessage = false;
            this.$router.push({path:"/my/account/member"});
        },


        //底部导航
        bannerClick(url){
            this.toBanner = true;
            this.$router.push({path:url})
        },

        //页面刷新验证
        checkDateAndRefreshIfNeeded() {
            const savedDateString = localStorage.getItem('savedDate');// 从 localStorage 中获取保存的日期
            let savedDate = new Date(0); // 默认设置为一个很早的日期
            if (savedDateString) {
                savedDate = new Date(savedDateString);
            }
            const currentDate = new Date();// 获取当前日期（仅年月日）
            currentDate.setHours(0, 0, 0, 0); // 重置时间为当天的开始
            // savedDate.setHours(0, 0, 0, 0); // 重置保存日期的时间为当天的开始
            if (currentDate > savedDate) {// 比较当前日期和保存的日期（仅年月日）
                localStorage.setItem('savedDate', currentDate);// 更新保存的日期为当前日期（年月日）
                window.location.reload();// 刷新页面
            }
        },

        async getPraView(){
            try {
                let response = await axios.post(this.$store.state.webUrl+"/app01/practise_view_get",{
                    userID:this.userID, 
                });
                let data = response.data
                console.log("getPraView_data:::",data)
                this.questionMessage = data.questionMessage;
                storage.set("practice_questionMessage",data.questionMessage);
                this.$store.commit("setQueNums",this.questionMessage); //将获取到的数组赋值给store待调用
            } catch (error) {
                this.$router.push({path:"/login"})
                console.error('Error fetching data:', error);
            }
        },


        //点击导航按钮
        toPathClick(url){
            this.canToPath = true;
            this.$router.push({path:url})
        },

        //关闭领取免费使用名额面板
        closebutton(){
            this.showCoupon = false;
        },
    }

}
</script>
<style scoped>
    /*以下为Top+Banner+Middle框样式设置*/
/*    .home{width: 100%;height: 100%;display: flex;justify-content: center;align-items: flex-end;}*/
    #Middle{width: 100%;height:88vh;background: #ededed; overflow: auto;display: flex;flex-direction: column;align-items: center;}
    #Banner{height: 60px;width: 100%;background: #f7f7f7;display: flex;justify-content: space-around;align-items: center;border-top: 1px solid #e5e5e5; box-sizing: border-box;position: absolute;bottom: 0}
    .text{color: #191919}
    .practise{color: #07c160;}
    #Banner img{width: 24px;height: 24px;}
    #Banner .practise, .text{display: flex;flex-flow: column;align-items: center;font-size: 16px;cursor: pointer;}
    /*以上为Top+Banner+Middle框样式设置*/

    /*以下为PraViewTop样式设置*/
    #PraViewTop{width: 100%;height: 27px;line-height: 27px;margin-top: 18px;display: flex;justify-content: flex-end;align-items: center;}
    .router{width: 140px;display: flex;justify-content: flex-end;align-items: center;margin-right: 10px;cursor: pointer;}
    .icon{height: 15px;width: 15px;}
    .setText{font-size: 14px;margin-right: 4px;color: #6f6d6d;}
    /*以上为PraViewTop框样式设置*/

    /*以下为个性化设置*/
    .wordPraView{width: 90%; margin-top: 20px;background: white;padding: 15px 0 30px 0;border-radius: 10px;}
    .practiseCenter{width: 100%;display: flex;justify-content: center;align-items: center;-background: yellow;}
    .practiseNumber{width: 100%;display: flex;justify-content: center;align-items: center; -background: pink;margin-bottom: 8px;margin-top: -18px;}
    .quedays{margin-bottom: 5px;}
    #plan{width: 100%;font-size: 11px;color: #6f6d6d;}
    #start{height: 60px;width: 100%; text-align: center;line-height: 60px;font-size: 25px;}
    
    .btnQue{border: .1px solid #6f6d6d;background: #038340;border-radius: 13px;padding: 12px 34px 15px 34px;cursor: pointer; color:#e5e5e5;text-align: center;line-height: 27px;box-shadow: 5px 5px 10px 0 rgba(0, 0, 0, 0.5);}
    .practiseBox{width: 100%;height: 90vh;-background: pink; display: flex;align-items: center; justify-content: center;flex-direction: column;}

    #report_show{font-size: 10px;color: #6f6d6d;}

    #days_num{font-size: 45px;color: red;text-align: center;margin-bottom: 17px;}
    .days_all{text-align: center;font-size:20px;}
    .little_num{color: red;}

    .deadline{width: 100%;height:87vh; display: flex;justify-content: center;align-items: center;text-align: center;}

    .practiseItemForm{width: 98%; display: flex;justify-content: space-evenly;margin-top: 20px;}

    .practiseItem{display: flex;flex-direction: column;align-items: center;justify-content: center;cursor: pointer;}
    .iconSize{width: 38px;margin-bottom: 5px;}


    .build_que_each_Num{width: 160px;display: flex;justify-content: space-evenly;align-items: center; font-size:10px ;color: #5b5b5b;-background: yellow;}
    .data_number{display: flex;flex-direction: column; align-items: center;justify-content: center;}
    .line{height: 25px;width: 1px;border-left: 1px solid #d7d5d5;}
    .each_time_color{color: red;font-size: 13px;margin-bottom: 13px;}
    .number_tittle{font-size: 10px;}



    .shade{background: rgba(108, 108, 107, 0.7);position: absolute;top: 0;left:0;bottom: 0;right: 0;  opacity: 1;display: flex;justify-content: center;align-items: center;}
    .messageForm{background: white;width: 300px;-height: 230px;border-radius: 5px;}
    .messageTitle{width: 100%;height: 55px;text-align: center;line-height: 55px;color: 191919;}
    .messageText{-height: 130px;padding: 0 20px 20px 20px;color: #737373;display: flex;justify-content: flex-start;}
    .messageSpan{color: #737373;font-size: 15px;text-indent: 30px;}
    .messageBtn{width: 100%;height: 45px;border-top:1px solid #e5e5e5;text-align: center;line-height: 45px;color: #566c95;-box-sizing: content-box;cursor: pointer;}


    /*加载更新效果*/
    .loadingForm {position: absolute;top: 0;left:0;bottom: 0;right: 0;  opacity: 1;display: flex;justify-content: center;align-items: center;flex-direction: column;z-index: 999;}
    .message {width: 100px;height: 100px; background-color: #4c4c4c;-border: 1px solid #ffffff;border-radius: 5px;display: flex;justify-content: center;align-items: center;flex-direction: column;padding: 20px;}

    .circle {border: 3px solid #ffffff; border-top: 3px solid #a3a3a2; border-radius: 50%;width: 30px;height: 30px;animation: spin 2s linear infinite; margin-bottom: 10px;}    
    @keyframes spin {0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); }}
    
    .showText{color: #ffffff;font-size: 15px;text-align: center;}
    /*加载更新效果*/


    /*显示领取免费使用名额弹窗*/
    .couponShade{background: rgba(108, 108, 107, 0.9);position: absolute;top: 0;left:0;bottom: 0;right: 0;  opacity: 1;display: flex;justify-content: center;align-items: center;flex-direction: column;z-index: 1010;-background: pink;}
    .couponForm{position: relative;width: 220px;height: 220px; background-color: white;border-radius: 5px;display: flex;justify-content: space-between;align-items: center;flex-direction: column;-padding: 20px;}
    .textAndCode{padding: 20px;display: flex;flex-direction: column;justify-content: center;align-items: center;color: red;}
    .vx_service_img{height: 120px;width: 120px;margin-top: 15px}
    .closebutton{position: absolute;height: 20px;width: 20px;top: 230px;left: 100px;cursor: pointer;}
    /*显示领取免费使用名额弹窗*/


</style>
